<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <g :fill="iconColor">
      <path
        d="M13.2344 0.890625L12.2188 1.78906C12.1797 1.82812 12.1406 1.86719 12.1016 1.90625C11.5938 1.82812 11.0469 1.75 10.5 1.75C5.65625 1.75 1.75 5.69531 1.75 10.5C1.75 15.3438 5.65625 19.25 10.4609 19.25C15.3047 19.25 19.2109 15.3438 19.2109 10.5C19.2109 9.95312 19.1719 9.40625 19.0938 8.89844C19.1328 8.85938 19.1719 8.82031 19.2109 8.78125L20.1094 7.76562C20.3438 8.625 20.5 9.5625 20.5 10.5C20.5 16.0469 16.0078 20.5 10.5 20.5C4.95312 20.5 0.5 16.0469 0.5 10.5C0.5 4.99219 4.95312 0.5 10.5 0.5C11.4375 0.5 12.375 0.65625 13.2344 0.890625ZM11.2031 4.32812C11.2031 4.40625 11.2422 4.52344 11.2422 4.64062L11.3984 5.61719C11.125 5.53906 10.8125 5.5 10.5 5.5C7.72656 5.5 5.5 7.76562 5.5 10.5C5.5 13.2734 7.72656 15.5 10.5 15.5C13.2344 15.5 15.5 13.2734 15.5 10.5C15.5 10.1875 15.4609 9.875 15.3828 9.60156L16.3594 9.75781C16.4766 9.75781 16.5938 9.79688 16.6719 9.79688C16.7109 10.0312 16.75 10.2656 16.75 10.5C16.75 13.9766 13.9375 16.75 10.5 16.75C7.02344 16.75 4.25 13.9766 4.25 10.5C4.25 7.0625 7.02344 4.25 10.5 4.25C10.7344 4.25 10.9688 4.28906 11.2031 4.32812ZM13.8203 8.07812L10.9297 10.9688C10.6953 11.2031 10.2656 11.2031 10.0312 10.9688C9.79688 10.7344 9.79688 10.3047 10.0312 10.0703L12.9219 7.17969L12.4922 4.44531C12.375 3.78125 12.6094 3.15625 13.0781 2.72656L15.0312 1.00781C15.5391 0.539062 16.3203 0.773438 16.5156 1.4375L17.2188 3.78125L19.5625 4.48438C20.2266 4.67969 20.4609 5.46094 19.9922 5.96875L18.2734 7.92188C17.8438 8.39062 17.2188 8.625 16.5547 8.50781L13.8203 8.07812ZM14.9141 6.98438L16.7891 7.29688C16.9844 7.33594 17.2188 7.25781 17.3359 7.10156L18.7422 5.53906L16.9062 4.99219L14.9141 6.98438ZM16.0078 4.09375L15.4609 2.25781L13.8984 3.66406C13.7422 3.78125 13.6641 4.01562 13.7031 4.21094L14.0156 6.08594L16.0078 4.09375Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
